/* sk8 Monster Drops, tema PS2, hero-texto.js.
   Texto da hero em baixa resolucao de PS2 (28/09/2026, pedido do Vini: "aplica
   o efeito low resolution aqui nos textos tambem"). Arquivo proprio, carregado
   com async logo depois da hero (sections/hero-skatista.liquid): roda assim que
   chega, sem esperar o resto da pagina como o hero.js (defer), e na volta a
   home o desenho sai do cache da sessao junto com a primeira pintura. Nao
   depende do base.js; expoe SK8.textoLowres.redesenhar(). Intensidade e piso
   de leitura: fim do hero.css. */
(function () {
  "use strict";

  /* ---------- texto em baixa resolucao de PS2 (28/09/2026) ----------
     Pedido do Vini: "aplica o efeito low resolution aqui nos textos tambem".
     Cada elemento com [data-lowres] cujo --lowres (hero.css) seja maior que
     zero ganha um <canvas aria-hidden> por cima, com as mesmas letras
     desenhadas numa grade reduzida e ampliadas sem suavizar
     (image-rendering: pixelated). O texto de verdade continua no HTML, no
     mesmo lugar, e so fica transparente ([data-lowres-ok]) depois que o
     canvas esta pronto: leitor de tela, selecao, busca da pagina, SEO e
     tradutor continuam lendo o texto. Sem JS, sem canvas ou antes da fonte
     carregar, aparece o texto normal.
     Como sai o pixel (2a versao, depois da conferencia de 28/09/2026):
     1. tamanho do pixel = tamanho da letra / --lowres (pixels da grade por
        em), arredondado para pixel inteiro da tela, com piso de legibilidade
        (21 pixels da grade por em no negrito, 18 no regular);
     2. cada letra diferente vira um bitmap proprio (cache por fonte,
        tamanho e letra). A letra e desenhada Q vezes maior que a grade e o
        encaixe na grade e escolhido entre Q x Q deslocamentos de menos de
        um pixel: fica o que deixa cada bloco mais perto de cheio ou vazio.
        E o "hinting" das fontes de tela: a barra do meio do "E" cai inteira
        num bloco em vez de ficar meio em dois (e sumir);
     3. o bloco e letra quando o centro dele esta dentro da letra (quina
        reta continua reta), com ajuste de traco e de vao mais finos que o
        bloco (ver bitmap());
     4. o deslocamento vertical e um so por fonte, entao a linha de base
        continua reta; o horizontal e por letra, com no maximo meio pixel de
        desvio;
     5. entre duas letras que tem vao no desenho da fonte fica sempre pelo
        menos um pixel vazio (senao a letra de tras anda um pixel);
     6. o contorno e a sombra dura saem do text-shadow do proprio elemento,
        cada deslocamento convertido em pixels inteiros da grade.
     Primeiro desenho: em passos curtos, ate ~8 ms por quadro, e a troca de
     todos no mesmo quadro no fim (sem troca em escada). Redesenho so
     quando o tamanho, o texto, a densidade ou a fonte mudam; no giro do
     celular e no resize ele roda no aviso do ResizeObserver, que vem depois
     do layout e antes da pintura: o canvas velho nao aparece fora do lugar.
     Nada roda por quadro depois disso: o video por baixo nao repinta o
     texto. Celular com ate 2 GB de memoria fica com o texto normal. */
  function textoLowres(raiz) {
    var alvos = raiz ? [].slice.call(raiz.querySelectorAll("[data-lowres]")) : [];
    if (!alvos.length || !window.ResizeObserver || !window.MutationObserver || !document.fonts || !document.fonts.load || !window.Map) return;
    // celular muito fraco (ate 2 GB de memoria; so o Chrome informa): fica o texto normal
    if (navigator.deviceMemory && navigator.deviceMemory <= 2) return;
    var teste = document.createElement("canvas").getContext("2d", { willReadFrequently: true });
    if (!teste || !teste.getImageData) return;
    var m0 = teste.measureText("x");
    if (!m0.fontBoundingBoxAscent || m0.actualBoundingBoxRight == null) return;

    var atlas = document.createElement("canvas"), corCtx = null, cores = {};
    var cache = new Map(), assinatura = new WeakMap();
    // o desenho pronto de cada elemento fica guardado na sessao (sessionStorage,
    // como a abertura): na volta a home ele sai do cache no primeiro quadro, sem
    // refazer as letras. VERSAO muda quando o jeito de desenhar muda
    var VERSAO = "lowres-2b";
    function lerSessao(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
    function gravarSessao(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
    // pixels do canvas em paleta + trechos iguais seguidos (poucos KB por elemento)
    function codificar(W, H, d) {
      var pal = [], idx = {}, trechos = [], ult = -1, n = 0;
      for (var o = 0; o < d.length; o += 4) {
        var c4 = d[o + 3] ? d[o] + "," + d[o + 1] + "," + d[o + 2] + "," + d[o + 3] : "0", i = idx[c4];
        if (i == null) { i = idx[c4] = pal.length; pal.push(c4); }
        if (i === ult) n++; else { if (n) trechos.push(ult, n); ult = i; n = 1; }
      }
      trechos.push(ult, n);
      return [W, H, pal, trechos.join(",")];
    }
    function doCache(job) {
      var txt = lerSessao(job.idCache), v;
      if (!txt) return false;
      try { v = JSON.parse(txt); } catch (e) { return false; }
      if (!v || v[0] !== job.chaveCache) return false;
      var W = v[1][0], H = v[1][1], pal = v[1][2].map(function (c4) { return c4 === "0" ? [0, 0, 0, 0] : c4.split(",").map(Number); }), tr = v[1][3].split(",");
      if (Math.abs(W - job.W) > 1 || Math.abs(H - job.H) > 1) return false;
      job.W = W; job.H = H; // o desenho guardado pode ter um pixel da grade a mais ou a menos
      var cv = job.cv || novoCanvas();
      cv.width = W; cv.height = H;
      var ctx = cv.getContext("2d"), img = ctx.createImageData(W, H), d = img.data, o = 0;
      for (var r = 0; r < tr.length; r += 2) {
        var c = pal[+tr[r]];
        for (var n = +tr[r + 1]; n > 0 && o < d.length; n--, o += 4) { d[o] = c[0]; d[o + 1] = c[1]; d[o + 2] = c[2]; d[o + 3] = c[3]; }
      }
      ctx.putImageData(img, 0, 0);
      job.cvNovo = cv; // saiu do cache
      return true;
    }
    function novoCanvas() {
      var cv = document.createElement("canvas");
      cv.className = "lowres";
      cv.setAttribute("aria-hidden", "true");
      cv.style.position = "absolute";
      return cv;
    }
    var LAMBDA = 1; // custo de 1 pixel de desvio da posicao real, na mesma escala do erro de encaixe

    function sombras(txt) {
      var saida = [], re = /(rgba?\([^)]*\)|#[0-9a-f]{3,8}|[a-z]+)\s+(-?[\d.]+)px\s+(-?[\d.]+)px/gi, m;
      if (!txt || txt === "none") return saida;
      while ((m = re.exec(txt))) saida.push({ cor: m[1], dx: parseFloat(m[2]), dy: parseFloat(m[3]) });
      return saida;
    }
    // cor do CSS em [r, g, b, a] (0 a 255); o que nao for rgb()/rgba() o
    // proprio canvas resolve
    function cor(txt) {
      if (txt in cores) return cores[txt];
      var m = /^rgba?\(\s*([\d.]+)[,\s]+([\d.]+)[,\s]+([\d.]+)(?:[,\s\/]+([\d.]+)(%?))?\s*\)$/.exec(txt), c;
      if (m) c = [+m[1], +m[2], +m[3], Math.round((m[4] == null ? 1 : m[5] ? m[4] / 100 : +m[4]) * 255)];
      else {
        if (!corCtx) { var c1 = document.createElement("canvas"); c1.width = c1.height = 1; corCtx = c1.getContext("2d", { willReadFrequently: true }); }
        corCtx.clearRect(0, 0, 1, 1); corCtx.fillStyle = "#000"; corCtx.fillStyle = txt; corCtx.fillRect(0, 0, 1, 1);
        c = [].slice.call(corCtx.getImageData(0, 0, 1, 1).data);
      }
      return (cores[txt] = c);
    }
    // deslocamento em px da tela para pixels inteiros da grade (nunca some)
    function passo(v, b) { return v === 0 ? 0 : (v > 0 ? 1 : -1) * Math.max(1, Math.round(Math.abs(v) / b)); }
    function caixa(t, tt) { return tt === "uppercase" ? t.toLocaleUpperCase("pt-BR") : tt === "lowercase" ? t.toLocaleLowerCase("pt-BR") : t; }
    // largura do comeco da palavra ate a letra, na fonte e no kerning do elemento
    // (o body desliga o kerning, mas o "font" do titulo e do preco religa)
    var fonteTeste = "", kernTeste = "", avanco = {};
    function largura(fonte, kern, trecho) {
      var k = fonte + "|" + kern + "|" + trecho;
      if (!(k in avanco)) {
        if (fonte !== fonteTeste) { teste.font = fonteTeste = fonte; }
        if (kern !== kernTeste) { teste.fontKerning = kernTeste = kern; }
        avanco[k] = trecho ? teste.measureText(trecho).width : 0;
      }
      return avanco[k];
    }

    /* ---- 1. medir: le o layout e devolve o trabalho (ou null) ---- */
    function medir(el) {
      var cv = el.querySelector(":scope > canvas.lowres");
      el.removeAttribute("data-lowres-ok"); // le cor e sombra originais (o CSS so as esconde com o atributo)
      var cs = getComputedStyle(el);
      var ppe = parseFloat(cs.getPropertyValue("--lowres")) || 0;
      if (!ppe || !el.getClientRects().length) { if (cv) cv.remove(); assinatura.delete(el); return null; }
      var dpr = window.devicePixelRatio || 1;
      var tam = parseFloat(cs.fontSize);
      // piso de legibilidade: com menos de 21 pixels da grade por em no negrito
      // o "R$" desta fonte e lido como "A$" (bancada de 28/09/2026: 17 a 19 leem
      // "A$", 20 no limite); o regular fica em 18. O pixel encolhe um pixel da
      // tela por vez ate passar do piso
      var min = parseFloat(cs.getPropertyValue("--lowres-min")) || (parseInt(cs.fontWeight, 10) >= 600 ? 21 : 18);
      var bDev = Math.max(1, Math.round(tam / ppe * dpr)); // pixel da grade em pixels da tela
      while (bDev > 1 && tam * dpr / bDev < min) bDev--;
      var b = bDev / dpr;                                   // e em px de CSS
      var r0 = el.getBoundingClientRect();
      var corteCss = parseFloat(cs.getPropertyValue("--lowres-corte"));
      var chave = [r0.width, r0.height, dpr, bDev, corteCss, el.textContent].join("|");
      if (cv && assinatura.get(el) === chave) { el.setAttribute("data-lowres-ok", ""); return null; }

      // posicao de cada letra: o layout do navegador da o inicio de cada palavra
      // e a fonte da o avanco de cada letra dentro dela
      var rg = document.createRange(), tw = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
      var itens = [], fontes = {}, n, falta = false;
      var minX = r0.left, minY = r0.top, maxX = r0.right, maxY = r0.bottom;
      function guardar(ch, x, rr, fo) {
        itens.push({ ch: ch, x: x, y: rr.top + fo.asc, fo: fo });
        if (rr.left < minX) minX = rr.left; if (rr.right > maxX) maxX = rr.right;
        if (rr.top < minY) minY = rr.top; if (rr.bottom > maxY) maxY = rr.bottom;
      }
      while ((n = tw.nextNode())) {
        var pe = n.parentElement;
        if (!pe || pe.closest("canvas")) continue;
        var pcs = getComputedStyle(pe);
        var fonte = pcs.fontStyle + " " + pcs.fontWeight + " " + pcs.fontSize + " " + pcs.fontFamily;
        if (!(fonte in fontes)) {
          // confere so a primeira familia: com a lista inteira o navegador procura
          // "Arial Narrow" e Arial no sistema e a primeira chamada custava ~30 ms (CPU 4x)
          var essa = pcs.fontStyle + " " + pcs.fontWeight + " " + pcs.fontSize + " " + pcs.fontFamily.split(",")[0];
          if (!document.fonts.check(essa)) { falta = true; document.fonts.load(essa).then(function () { atualizar(el, true); }); }
          if (fonte !== fonteTeste) { teste.font = fonteTeste = fonte; }
          // Q: quantas vezes a letra e desenhada maior que a grade (mais Q = mais
          // encaixes testados). O molde fica com pelo menos 88 px por em: o corte
          // fino do "R" precisa de 2 pixels do molde para ser visto (com 64 o "R"
          // de 22 e 23 pixels da grade por em voltava a ser "A"). Com pixel de 1
          // pixel da tela (texto pequeno) nao ha encaixe a escolher: o molde e a
          // propria letra do navegador, so sem o meio-tom
          var ppeF = parseFloat(pcs.fontSize) / b, Q = bDev === 1 ? 1 : Math.max(3, Math.min(6, Math.ceil(88 / ppeF)));
          var px = Q === 1 ? +ppeF.toFixed(2) : Math.max(8, Math.round(ppeF * Q));
          fontes[fonte] = {
            asc: teste.measureText("Hg").fontBoundingBoxAscent, Q: Q,
            f: pcs.fontStyle + " " + pcs.fontWeight + " " + px + "px " + pcs.fontFamily,
            corte: corteCss > 0 && corteCss < 1 ? corteCss : parseInt(pcs.fontWeight, 10) >= 600 ? 0.5 : 0.45
          };
        }
        var fo = fontes[fonte], ls = parseFloat(pcs.letterSpacing) || 0, tt = pcs.textTransform;
        var kern = pcs.fontKerning === "none" ? "none" : "normal";
        var s = n.data, re = /\S+/g, m;
        while ((m = re.exec(s))) {
          rg.setStart(n, m.index); rg.setEnd(n, m.index + m[0].length);
          var rs = rg.getClientRects();
          if (rs.length === 1) {
            var pal = caixa(m[0], tt), x = rs[0].left;
            for (var i = 0, nl = 0; i < pal.length; i++, nl++) {
              var c = pal.charCodeAt(i), len = (c >= 0xd800 && c <= 0xdbff) ? 2 : 1, ch = pal.substr(i, len);
              // inicio da letra = palavra ate ela, inclusive, menos o avanco dela
              // (o par "TA" puxa o A 14 px para a esquerda em 1920)
              guardar(ch, x + largura(fonte, kern, pal.slice(0, i + len)) - largura(fonte, kern, ch) + nl * ls, rs[0], fo);
              i += len - 1;
            }
          } else if (rs.length > 1) {
            // palavra partida entre duas linhas: mede letra por letra
            for (var j = 0; j < m[0].length; j++) {
              var c2 = m[0].charCodeAt(j), len2 = (c2 >= 0xd800 && c2 <= 0xdbff) ? 2 : 1;
              rg.setStart(n, m.index + j); rg.setEnd(n, m.index + j + len2);
              var r1 = rg.getClientRects()[0];
              if (r1) guardar(caixa(m[0].substr(j, len2), tt), r1.left, r1, fo);
              j += len2 - 1;
            }
          }
        }
      }
      if (falta || !itens.length) { if (cv) cv.remove(); assinatura.delete(el); return null; }

      // contorno e sombra dura: a menor sombra do CSS e o contorno; a que ia
      // alem dele continua pelo menos um pixel da grade alem
      var sh = sombras(cs.textShadow), menor = Infinity;
      sh.forEach(function (o) { var v = Math.max(Math.abs(o.dx), Math.abs(o.dy)); if (v && v < menor) menor = v; });
      var contorno = menor === Infinity ? 0 : passo(menor, b), desl = [], vistos = {}, pad = 1;
      sh.forEach(function (o) {
        var dx = passo(o.dx, b), dy = passo(o.dy, b);
        if (Math.max(Math.abs(o.dx), Math.abs(o.dy)) > menor) {
          if (o.dx && Math.abs(dx) <= contorno) dx = (o.dx > 0 ? 1 : -1) * (contorno + 1);
          if (o.dy && Math.abs(dy) <= contorno) dy = (o.dy > 0 ? 1 : -1) * (contorno + 1);
        }
        var k = dx + "," + dy + "," + o.cor;
        if (vistos[k]) return;
        vistos[k] = 1;
        desl.push({ dx: dx, dy: dy, cor: o.cor });
        pad = Math.max(pad, Math.abs(dx) + 1, Math.abs(dy) + 1);
      });
      pad += 2; // folga para o encaixe (meio pixel) e o pixel que a letra anda para nao colar
      // risco do preco "de" (::after com fundo na cor do texto, hero.css)
      var barra = null, ps = getComputedStyle(el, "::after");
      if (ps.content && ps.content !== "none" && ps.display !== "none" && ps.position === "absolute") {
        barra = {
          x0: r0.left + (parseFloat(ps.left) || 0), x1: r0.right - (parseFloat(ps.right) || 0),
          y: r0.top + (parseFloat(ps.top) || 0), h: parseFloat(ps.height) || 0,
          cor: ps.backgroundColor, sombra: sombras(ps.boxShadow)
        };
        minX = Math.min(minX, barra.x0); maxX = Math.max(maxX, barra.x1);
      }

      // grade presa aos pixels da tela (origem inteira), com folga para as sombras
      var sx = window.scrollX || 0, sy = window.scrollY || 0;
      var ox = Math.floor((minX + sx) * dpr) - pad * bDev, oy = Math.floor((minY + sy) * dpr) - pad * bDev;
      var job = {
        el: el, cv: cv, chave: chave, itens: itens, desl: desl, barra: barra, corTexto: cs.color,
        dpr: dpr, b: b, bDev: bDev, ox: ox, oy: oy, sx: sx, sy: sy, r0: r0,
        W: Math.ceil(((maxX + sx) * dpr - ox) / bDev) + pad, H: Math.ceil(((maxY + sy) * dpr - oy) / bDev) + pad
      };
      job.gx = function (x) { return ((x + sx) * dpr - ox) / bDev; };
      job.gy = function (y) { return ((y + sy) * dpr - oy) / bDev; };
      // tudo o que muda o desenho entra na chave do cache: tamanho, densidade,
      // texto, fontes, cores, sombras, risco e a posicao de cada letra dentro do
      // elemento (e nao na tela: na 1a visita a abertura tira a barra de rolagem
      // e a hero fica meio pixel ao lado; o desenho guardado serve igual)
      job.idCache = "sk8-lowres:" + alvos.indexOf(el);
      job.chaveCache = [VERSAO, chave, cs.color, cs.textShadow, JSON.stringify(barra && { l: barra.x0 - r0.left, r: r0.right - barra.x1, t: barra.y - r0.top, h: barra.h, c: barra.cor, s: barra.sombra }),
        Object.keys(fontes).map(function (f) { return f + ">" + fontes[f].f + ">" + fontes[f].corte; }).join(";"),
        itens.map(function (it) { return it.ch + Math.round((it.x - r0.left) * 4) / 4 + "," + Math.round((it.y - r0.top) * 4) / 4; }).join(" ")].join("|");
      return job;
    }

    /* ---- 2. moldes: cada letra diferente, desenhada Q vezes maior ---- */
    // letras deste trabalho que ainda nao tem molde (cache por fonte, tamanho e letra)
    function faltando(job) {
      var novos = [], vistos = {};
      job.itens.forEach(function (it) {
        var k = it.fo.f + "|" + it.fo.Q + "|" + it.ch;
        it.k = k;
        if (cache.has(k) || vistos[k]) return;
        vistos[k] = 1;
        novos.push({ k: k, ch: it.ch, f: it.fo.f, Q: it.fo.Q });
      });
      return novos;
    }
    // um lote de letras num atlas so, lido de uma vez. De cada letra fica o alfa,
    // a soma acumulada (a tinta de qualquer bloco em 4 leituras) e o erro de
    // encaixe de cada deslocamento. O molde e so a tinta da letra mais a margem:
    // a linha de base entra pelo deslocamento medido a partir dela
    function moldes(novos) {
      novos = novos.filter(function (g) { return !cache.has(g.k); });
      if (!novos.length) return;
      var ac = atlas.getContext("2d", { willReadFrequently: true });
      var x = 0, y = 0, linha = 0, larg = 0, ult = "";
      novos.forEach(function (g) {
        if (g.f !== ult) { ac.font = ult = g.f; }
        var m = ac.measureText(g.ch), M = g.Q + 2;
        var L = Math.ceil(Math.max(0, m.actualBoundingBoxLeft)), R = Math.ceil(Math.max(0, m.actualBoundingBoxRight));
        var A = Math.ceil(Math.max(0, m.actualBoundingBoxAscent)), D = Math.ceil(Math.max(0, m.actualBoundingBoxDescent));
        g.Ox = M + L; g.By = M + A; g.rw = g.Ox + R + M; g.rh = g.By + D + M;
        if (x + g.rw > 2048 && x) { y += linha + 2; x = 0; linha = 0; }
        g.ax = x; g.ay = y; x += g.rw + 2; linha = Math.max(linha, g.rh); larg = Math.max(larg, x);
      });
      atlas.width = larg; atlas.height = y + linha; // limpa
      ac.fillStyle = "#fff"; ac.textBaseline = "alphabetic"; ac.fontKerning = "none"; ult = "";
      novos.forEach(function (g) {
        if (g.f !== ult) { ac.font = ult = g.f; }
        ac.fillText(g.ch, g.ax + g.Ox, g.ay + g.By);
      });
      var dados = ac.getImageData(0, 0, atlas.width, atlas.height).data, AW = atlas.width;
      novos.forEach(function (g) {
        var rw = g.rw, rh = g.rh, Q = g.Q, S = new Uint32Array((rw + 1) * (rh + 1)), A = new Uint8Array(rw * rh);
        var rmin = new Int16Array(rh), rmax = new Int16Array(rh);
        for (var yy = 0; yy < rh; yy++) {
          var soma = 0, lo = -1, hi = -1, base = ((g.ay + yy) * AW + g.ax) * 4 + 3, l0 = yy * (rw + 1) + 1, l1 = l0 + rw + 1;
          for (var xx = 0; xx < rw; xx++) {
            var a = dados[base + xx * 4];
            A[yy * rw + xx] = a;
            soma += a;
            if (a >= 128) { if (lo < 0) lo = xx; hi = xx; }
            S[l1 + xx] = S[l0 + xx] + soma;
          }
          rmin[yy] = lo; rmax[yy] = hi;
        }
        g.S = S; g.A = A; g.rmin = rmin; g.rmax = rmax; g.bm = {};
        // erro de encaixe de cada deslocamento: soma, bloco a bloco, do que
        // falta para cheio ou vazio (0 = a letra cai exatamente na grade)
        g.err = [];
        for (var fy = 0; fy < Q; fy++) {
          var py = (g.By + fy) % Q;
          for (var px = 0; px < Q; px++) g.err[fy * Q + px] = erro(g, px, py);
        }
        cache.set(g.k, g);
      });
    }
    function cobertura(g, x0, y0) {
      var Q = g.Q, w1 = g.rw + 1, x1 = Math.min(x0 + Q, g.rw), y1 = Math.min(y0 + Q, g.rh), S = g.S;
      return (S[y1 * w1 + x1] - S[y0 * w1 + x1] - S[y1 * w1 + x0] + S[y0 * w1 + x0]) / (Q * Q * 255);
    }
    function erro(g, px, py) {
      var e = 0, Q = g.Q;
      for (var y0 = py; y0 < g.rh; y0 += Q) for (var x0 = px; x0 < g.rw; x0 += Q) {
        var c = cobertura(g, x0, y0);
        e += c < 0.5 ? c : 1 - c;
      }
      return e;
    }
    // tinta no centro do bloco (media dos 2 x 2 pixels do meio, ou do pixel do meio)
    function centro(g, x0, y0) {
      var Q = g.Q, s = Q % 2 ? 1 : 2, a = x0 + ((Q - s) >> 1), c = y0 + ((Q - s) >> 1), w1 = g.rw + 1, S = g.S;
      if (a + s > g.rw || c + s > g.rh) return 0;
      return (S[(c + s) * w1 + a + s] - S[c * w1 + a + s] - S[(c + s) * w1 + a] + S[c * w1 + a]) / (s * s * 255);
    }
    // bitmap da letra num encaixe. O bloco e letra quando o CENTRO dele esta
    // dentro da letra e ele tem pelo menos metade da area com tinta (como as
    // fontes de tela): so pela area, a quina quadrada que cai no meio do bloco
    // sumia (0,7 x 0,7 = 0,49) e o "D" virava "O". Depois, dois ajustes finos,
    // olhando a reta entre os centros de dois blocos vizinhos:
    // - traco mais fino que o bloco passando entre dois centros apagados acende
    //   o bloco com mais tinta (senao a barra do "E" e do "e" sumia);
    // - vao mais fino que o bloco passando entre dois centros acesos apaga o
    //   bloco com menos tinta: e o corte entre a haste e a barra do meio do "R",
    //   o dente do lado direito dele, o miolo do "0" e do "e" (senao o "R" vira
    //   "A" e o "0" vira "D").
    // Guarda tambem, por linha, o primeiro e o ultimo bloco com tinta (pixel) e
    // onde a tinta comeca e acaba no desenho (para o vao entre letras)
    function bitmap(g, px, fy, corte) {
      var k = px + "," + fy + "," + corte;
      if (g.bm[k]) return g.bm[k];
      var Q = g.Q, py = (g.By + fy) % Q, nx = Math.ceil((g.rw - px) / Q), ny = Math.ceil((g.rh - py) / Q);
      var bits = new Uint8Array(nx * ny), area = new Float32Array(nx * ny), i, j, t;
      for (j = 0; j < ny; j++) for (i = 0; i < nx; i++) {
        t = j * nx + i;
        area[t] = cobertura(g, px + i * Q, py + j * Q);
        if (area[t] >= 0.5 && centro(g, px + i * Q, py + j * Q) >= corte) bits[t] = 1;
      }
      if (Q > 1) ajustar(g, px, py, nx, ny, bits, area);
      var esq = new Int16Array(ny), dir = new Int16Array(ny), vmin = new Float32Array(ny), vmax = new Float32Array(ny);
      for (j = 0; j < ny; j++) {
        esq[j] = dir[j] = -1; vmin[j] = Infinity; vmax[j] = -Infinity;
        for (i = 0; i < nx; i++) if (bits[j * nx + i]) { if (esq[j] < 0) esq[j] = i; dir[j] = i; }
        for (var yy = py + j * Q; yy < Math.min(py + (j + 1) * Q, g.rh); yy++) {
          if (g.rmin[yy] >= 0) { vmin[j] = Math.min(vmin[j], (g.rmin[yy] - px) / Q); vmax[j] = Math.max(vmax[j], (g.rmax[yy] + 1 - px) / Q); }
        }
      }
      return (g.bm[k] = { nx: nx, ny: ny, py: py, bits: bits, esq: esq, dir: dir, vmin: vmin, vmax: vmax });
    }
    function ajustar(g, px, py, nx, ny, bits, area) {
      var Q = g.Q, i, j, t;
      // tinta ao longo da reta entre o centro do bloco (i,j) e o do vizinho
      // (horizontal ou vertical), passo a passo; em Q par o centro fica entre
      // dois pixels do molde e o passo vale a media dos dois
      var A = g.A, rw = g.rw, s2 = Q % 2 ? 1 : 2, c0 = (Q - s2) >> 1;
      function pix(x, y) { return x < 0 || y < 0 || x >= rw || y >= g.rh ? 0 : A[y * rw + x]; }
      function reta(i0, j0, horiz, procura) { // procura 1: algum passo com tinta; 0: algum passo sem tinta
        var x = px + i0 * Q + c0, y = py + j0 * Q + c0;
        for (var n2 = 1; n2 < Q + (s2 === 2 ? 1 : 0); n2++) {
          var v = horiz ? (pix(x + n2, y) + (s2 === 2 ? pix(x + n2, y + 1) : pix(x + n2, y))) / 2 : (pix(x, y + n2) + (s2 === 2 ? pix(x + 1, y + n2) : pix(x, y + n2))) / 2;
          if ((v >= 128) === !!procura) return true;
        }
        return false;
      }
      // traco fino: a e o vizinho apagados, nenhum dos dois de fora aceso
      function liga(a, b2, antes, depois, i0, j0, horiz) {
        if (bits[a] || bits[b2] || area[a] + area[b2] < 0.4 || (antes >= 0 && bits[antes]) || (depois >= 0 && bits[depois])) return;
        if (reta(i0, j0, horiz, 1)) bits[area[a] >= area[b2] ? a : b2] = 1;
      }
      for (j = 0; j + 1 < ny; j++) for (i = 0; i < nx; i++) liga(j * nx + i, (j + 1) * nx + i, j ? (j - 1) * nx + i : -1, j + 2 < ny ? (j + 2) * nx + i : -1, i, j, false);
      for (j = 0; j < ny; j++) for (i = 0; i + 1 < nx; i++) liga(j * nx + i, j * nx + i + 1, i ? j * nx + i - 1 : -1, i + 2 < nx ? j * nx + i + 2 : -1, i, j, true);
      // vao fino: a e o vizinho acesos, com fundo entre os dois centros
      var apagar = [];
      for (j = 0; j < ny; j++) for (i = 0; i < nx; i++) {
        t = j * nx + i;
        if (!bits[t]) continue;
        // dois blocos cheios nao tem vao entre os centros: nem testa
        if (i + 1 < nx && bits[t + 1] && (area[t] < 0.98 || area[t + 1] < 0.98) && reta(i, j, true, 0)) apagar.push(area[t] < area[t + 1] ? t : t + 1);
        if (j + 1 < ny && bits[t + nx] && (area[t] < 0.98 || area[t + nx] < 0.98) && reta(i, j, false, 0)) apagar.push(area[t] < area[t + nx] ? t : t + nx);
      }
      apagar.forEach(function (t2) { bits[t2] = 0; });
      // reentrancia na borda (o dente do lado direito do "R" e do "B"): bloco da
      // beirada com bem menos tinta que os dois vizinhos ao longo da borda apaga
      var DENTE = 0.2;
      apagar = [];
      for (j = 1; j + 1 < ny; j++) for (i = 1; i + 1 < nx; i++) {
        t = j * nx + i;
        if (!bits[t]) continue;
        var bordaV = !bits[t - 1] || !bits[t + 1], bordaH = !bits[t - nx] || !bits[t + nx];
        if (bordaV && !bordaH && bits[t - nx] && bits[t + nx] && area[t] < Math.min(area[t - nx], area[t + nx]) - DENTE) apagar.push(t);
        else if (bordaH && !bordaV && bits[t - 1] && bits[t + 1] && area[t] < Math.min(area[t - 1], area[t + 1]) - DENTE) apagar.push(t);
      }
      apagar.forEach(function (t2) { bits[t2] = 0; });
    }
    // a letra B encosta na A (lado, ou quina) onde o desenho da fonte tem vao?
    function colado(A, B) {
      var a = A.bm, bb = B.bm;
      for (var k = 0; k < bb.ny; k++) {
        if (bb.esq[k] < 0) continue;
        var R = B.r + k, ka = R - A.r, pDir = -Infinity, vDir = -Infinity;
        for (var j = ka - 1; j <= ka + 1; j++) {
          if (j < 0 || j >= a.ny || a.dir[j] < 0) continue;
          pDir = Math.max(pDir, A.c + a.dir[j]);
          vDir = Math.max(vDir, A.c + a.vmax[j]);
        }
        if (pDir === -Infinity) continue;
        var vEsq = B.cReal + bb.vmin[k];
        if (vEsq - (A.cReal + (vDir - A.c)) >= 0.5 && B.c + bb.esq[k] - pDir < 2) return true;
      }
      return false;
    }

    /* ---- 3. rasterizar: encaixa as letras na grade e monta o canvas ---- */
    function rasterizar(job) { preparar(job); bitmaps(job, Infinity); montar(job); }
    function preparar(job) {
      moldes(faltando(job)); // no primeiro desenho os moldes ja vieram em lotes
      // deslocamento vertical: um por fonte (linha de base reta), o de menor erro somado
      var porFonte = {};
      job.itens.forEach(function (it) { (porFonte[it.fo.f] = porFonte[it.fo.f] || []).push(it); });
      Object.keys(porFonte).forEach(function (f) {
        var lista = porFonte[f], Q = lista[0].fo.Q, melhor = 0, menorErro = Infinity;
        for (var fy = 0; fy < Q; fy++) {
          var t = 0;
          lista.forEach(function (it) { var g = cache.get(it.k), mn = Infinity; for (var px = 0; px < Q; px++) mn = Math.min(mn, g.err[fy * Q + px]); t += mn; });
          if (t < menorErro - 1e-6) { menorErro = t; melhor = fy; }
        }
        lista.forEach(function (it) { it.fy = melhor; });
      });
      // horizontal: cada letra tem os encaixes em ordem de nota (erro de encaixe
      // mais o desvio da posicao real); o bitmap do melhor sai em lotes
      job.itens.forEach(function (it) {
        var g = cache.get(it.k), Q = g.Q, X = job.gx(it.x), cands = [];
        for (var px = 0; px < Q; px++) {
          var o = (g.Ox - px) / Q, c = Math.round(X - o);
          cands.push({ px: px, c: c, cReal: X - o, nota: g.err[it.fy * Q + px] + LAMBDA * Math.abs(c - (X - o)) });
        }
        cands.sort(function (p, q) { return p.nota - q.nota; });
        it.cands = cands;
      });
      job.faltaBm = job.itens.slice();
    }
    function bitmaps(job, n) {
      job.faltaBm.splice(0, n).forEach(function (it) { bitmap(cache.get(it.k), it.cands[0].px, it.fy, it.fo.corte); });
    }
    // na ordem do texto, sem colar na anterior; depois os pixels do canvas
    function montar(job) {
      var W = job.W, H = job.H, ant = null, colocados = [];
      job.itens.forEach(function (it) {
        var g = cache.get(it.k), Q = g.Q, X = job.gx(it.x), Y = job.gy(it.y), corte = it.fo.corte;
        var py = (g.By + it.fy) % Q, r = Math.round(Y - (g.By - py) / Q);
        var mesmaLinha = ant && Math.abs(ant.Y - Y) < 0.5 && X > ant.X;
        var cands = it.cands;
        var esc = null;
        for (var i = 0; i < cands.length && !esc; i++) {
          var tent = { X: X, Y: Y, r: r, c: cands[i].c, cReal: cands[i].cReal, bm: bitmap(g, cands[i].px, it.fy, corte) };
          if (!mesmaLinha || !colado(ant, tent)) esc = tent;
        }
        if (!esc) {
          esc = { X: X, Y: Y, r: r, c: cands[0].c, cReal: cands[0].cReal, bm: bitmap(g, cands[0].px, it.fy, corte) };
          for (var e = 0; e < 3 && colado(ant, esc); e++) esc.c++;
        }
        colocados.push(esc);
        ant = esc;
      });

      // monta os pixels em JS: a letra (1 bit na grade) e carimbada em cada
      // deslocamento de sombra, da ultima para a primeira como o CSS pinta, a
      // letra por cima e o risco do preco "de"; um putImageData so no canvas
      var tintaXY = [];
      colocados.forEach(function (p) {
        var bm = p.bm;
        for (var j = 0; j < bm.ny; j++) {
          var yy = p.r + j;
          if (yy < 0 || yy >= H || bm.esq[j] < 0) continue;
          for (var i = bm.esq[j]; i <= bm.dir[j]; i++) {
            var xx = p.c + i;
            if (xx >= 0 && xx < W && bm.bits[j * bm.nx + i]) tintaXY.push(xx, yy);
          }
        }
      });
      var cv = job.cv || novoCanvas();
      cv.width = W; cv.height = H;
      var ctx = cv.getContext("2d"), img = ctx.createImageData(W, H), d = img.data;
      function pinta(o, c) {
        if (c[3] >= 255) { d[o] = c[0]; d[o + 1] = c[1]; d[o + 2] = c[2]; d[o + 3] = 255; return; }
        if (c[3] <= 0) return;
        var a = c[3] / 255, da = d[o + 3] / 255 * (1 - a), oa = a + da;
        d[o] = (c[0] * a + d[o] * da) / oa; d[o + 1] = (c[1] * a + d[o + 1] * da) / oa; d[o + 2] = (c[2] * a + d[o + 2] * da) / oa; d[o + 3] = oa * 255;
      }
      function carimbo(dx, dy, c) {
        for (var n = 0; n < tintaXY.length; n += 2) {
          var x = tintaXY[n] + dx, y = tintaXY[n + 1] + dy;
          if (x >= 0 && x < W && y >= 0 && y < H) pinta((y * W + x) * 4, c);
        }
      }
      function retangulo(x0, y0, w, h, c) {
        for (var y = Math.max(0, y0); y < Math.min(H, y0 + h); y++) for (var x = Math.max(0, x0); x < Math.min(W, x0 + w); x++) pinta((y * W + x) * 4, c);
      }
      for (var q = job.desl.length - 1; q >= 0; q--) carimbo(job.desl[q].dx, job.desl[q].dy, cor(job.desl[q].cor));
      carimbo(0, 0, cor(job.corTexto));
      var barra = job.barra, b = job.b;
      if (barra) {
        var x0 = Math.round(job.gx(barra.x0)), x1 = Math.round(job.gx(barra.x1)), y0 = Math.round(job.gy(barra.y)), h = Math.max(1, Math.round(barra.h / b));
        barra.sombra.forEach(function (o) { retangulo(x0 + passo(o.dx, b), y0 + passo(o.dy, b), x1 - x0, h, cor(o.cor)); });
        retangulo(x0, y0, x1 - x0, h, cor(barra.cor));
      }
      ctx.putImageData(img, 0, 0);
      job.cvNovo = cv;
      gravarSessao(job.idCache, JSON.stringify([job.chaveCache, codificar(W, H, d)]));
    }

    /* ---- 4. aplicar: troca na pagina, todos os elementos no mesmo quadro ---- */
    function aplicar(job) {
      var cv = job.cvNovo, st = cv.style, el = job.el;
      st.left = (job.ox / job.dpr - job.sx - job.r0.left) + "px";
      st.top = (job.oy / job.dpr - job.sy - job.r0.top) + "px";
      st.width = (job.W * job.bDev / job.dpr) + "px";
      st.height = (job.H * job.bDev / job.dpr) + "px";
      if (cv.parentNode !== el) el.appendChild(cv);
      assinatura.set(el, job.chave);
      el.setAttribute("data-lowres-ok", "");
    }
    function desfazer(el) {
      var c0 = el.querySelector(":scope > canvas.lowres");
      if (c0) c0.remove();
      el.removeAttribute("data-lowres-ok");
      assinatura.delete(el);
    }
    function trabalho(el, sempre) {
      if (sempre) assinatura.delete(el);
      try { var j = medir(el); if (j && !doCache(j)) rasterizar(j); return j; } catch (e) { desfazer(el); return null; }
    }
    // REDESENHO (o elemento ja tem canvas: giro, resize, texto trocado): na hora,
    // todos juntos. Vindo do ResizeObserver, que avisa depois do layout e antes
    // da pintura, o canvas novo sai no mesmo quadro do tamanho novo
    function processar(lista, sempre) {
      var jobs = [];
      lista.forEach(function (el) { var j = trabalho(el, sempre); if (j) jobs.push(j); });
      jobs.forEach(function (j) { if (j.el.isConnected) aplicar(j); });
    }
    // PRIMEIRO DESENHO (ainda sem canvas; o texto normal esta na tela): em passos
    // curtos (medir; moldes em lotes de 4 letras; encaixe; bitmaps em lotes de 8
    // letras; montagem), ate ~8 ms
    // por quadro, e a troca de todos os elementos no mesmo quadro no fim: sem
    // troca em escada e sem tarefa longa no carregamento
    var fila = [], prontos = [], quadro = 0, LOTE = 4;
    // cada fatia roda logo depois de um quadro (requestAnimationFrame e dai uma
    // tarefa nova): o layout daquele quadro ja esta feito e a medida nao obriga o
    // navegador a refazer o layout da pagina ainda carregando dentro da nossa tarefa
    function proximo() { quadro = requestAnimationFrame(function () { setTimeout(fatia, 0); }); }
    function fatia() {
      quadro = 0;
      var t0 = performance.now();
      while (fila.length && performance.now() - t0 < 8) {
        var it = fila[0];
        try {
          if (!it.job) {
            if (it.sempre) assinatura.delete(it.el);
            it.job = medir(it.el);
            if (!it.job) { fila.shift(); continue; }
            if (doCache(it.job)) { prontos.push(it.job); fila.shift(); continue; }
            it.novos = faltando(it.job);
          } else if (it.novos.length) moldes(it.novos.splice(0, LOTE));
          else if (!it.job.faltaBm) preparar(it.job);
          else if (it.job.faltaBm.length) bitmaps(it.job, 2 * LOTE);
          else { montar(it.job); prontos.push(it.job); fila.shift(); }
        } catch (e) { desfazer(it.el); fila.shift(); }
      }
      if (fila.length) { proximo(); return; }
      var lista = prontos;
      prontos = [];
      lista.forEach(function (j2) { if (j2.el.isConnected) aplicar(j2); });
    }
    function atualizar(el, sempre) {
      if (el.querySelector(":scope > canvas.lowres")) return processar([el], sempre);
      prontos = prontos.filter(function (j) { return j.el !== el; }); // medida velha sai
      var it = null;
      fila.forEach(function (x) { if (x.el === el) it = x; });
      if (it) { it.job = null; it.sempre = it.sempre || sempre; } // mede de novo
      else fila.push({ el: el, sempre: sempre });
      if (!quadro) proximo();
    }
    function todos() { alvos.forEach(function (el) { atualizar(el, true); }); }

    var ro = new ResizeObserver(function (es) {
      var agora = [];
      es.forEach(function (e) {
        var el = e.target;
        if (el.querySelector(":scope > canvas.lowres")) return agora.push(el);
        // primeiro aviso de um elemento que ja esta na fila com a mesma medida: segue
        var it = null;
        fila.forEach(function (x) { if (x.el === el) it = x; });
        if (it && it.job) { var r = el.getBoundingClientRect(); if (r.width === it.job.r0.width && r.height === it.job.r0.height) return; }
        if (!it || it.job) atualizar(el);
      });
      if (agora.length) processar(agora);
    });
    var mo = new MutationObserver(function (ms) {
      var lista = [];
      ms.forEach(function (m) {
        var nossa = m.type === "childList" && [].slice.call(m.addedNodes).concat([].slice.call(m.removedNodes))
          .every(function (x) { return x.nodeName === "CANVAS"; });
        var alvo = m.target.nodeType === 1 ? m.target : m.target.parentElement;
        var el = !nossa && alvo && alvo.closest ? alvo.closest("[data-lowres]") : null;
        if (el && lista.indexOf(el) < 0) lista.push(el);
      });
      lista.forEach(function (el) { atualizar(el, true); }); // tradutor e editor do tema
    });
    // este arquivo chega com async e pode rodar antes das folhas de estilo: so
    // comeca quando todas as que vem antes da hero ja carregaram (a fonte vem do
    // base.css, o --lowres do hero.css); depois espera so as fontes destes textos
    var comecou = false, esperas = 0;
    function cssPronto() {
      return [].every.call(document.querySelectorAll('link[rel="stylesheet"]'), function (l) {
        return l.sheet || l.disabled || !(l.compareDocumentPosition(alvos[0]) & 4);
      });
    }
    function comecar() {
      if (comecou) return;
      if (!cssPronto() && esperas++ < 600) return requestAnimationFrame(comecar);
      comecou = true;
      var faces = {};
      alvos.forEach(function (el) {
        var cs = getComputedStyle(el);
        faces[cs.fontStyle + " " + cs.fontWeight + " 16px " + cs.fontFamily.split(",")[0]] = 1;
      });
      Promise.all(Object.keys(faces).map(function (f) { return document.fonts.load(f).catch(function () {}); })).then(function () {
        alvos.forEach(function (el) {
          atualizar(el, true); // entra na fila ja, sem esperar o primeiro aviso do ResizeObserver
          ro.observe(el);
          mo.observe(el, { childList: true, characterData: true, subtree: true });
        });
      });
    }
    comecar();
    // --lowres muda no ponto de quebra; a densidade muda com zoom ou troca de monitor
    var mq = window.matchMedia && matchMedia("(min-width: 1000px)");
    if (mq && mq.addEventListener) mq.addEventListener("change", todos);
    var dprVisto = window.devicePixelRatio || 1;
    function trocouDensidade() {
      var d = window.devicePixelRatio || 1;
      if (d !== dprVisto) { dprVisto = d; todos(); }
    }
    (function densidade() {
      if (!window.matchMedia) return;
      var m = matchMedia("(resolution: " + dprVisto + "dppx)");
      if (!m.addEventListener) return;
      m.addEventListener("change", function () { trocouDensidade(); densidade(); }, { once: true });
    })();
    window.addEventListener("resize", trocouDensidade); // zoom do navegador; so trabalha se a densidade mudou
    return { redesenhar: todos };
  }

  var lowres = textoLowres(document.querySelector(".hero"));
  if (lowres) { window.SK8 = window.SK8 || {}; window.SK8.textoLowres = lowres; }
})();
